export const TermsSection2 = () => {
  return (
    <>
      <section id="facebook-compliance">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          4. Facebook Platform Compliance
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-4">
              IMPORTANT: By using our Service to integrate with Facebook, Instagram, or WhatsApp,
              you agree to comply with the following third-party terms and policies:
            </p>
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            4.1 Required Compliance with Meta Platform Terms
          </h3>
          <p>You agree to comply with:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              <a
                href="https://developers.facebook.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Facebook Platform Terms
              </a>{' '}
              and{' '}
              <a
                href="https://developers.facebook.com/policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Facebook Platform Policy
              </a>
            </li>
            <li>
              <a
                href="https://www.whatsapp.com/legal/business-terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                WhatsApp Business Terms of Service
              </a>
            </li>
            <li>
              <a
                href="https://developers.facebook.com/terms/dfc_platform_terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Instagram Platform Terms
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/privacy/policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Meta Privacy Policy
              </a>
            </li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            4.2 Restrictions on Facebook Data Usage
          </h3>
          <p>
            When using data obtained from Facebook, Instagram, or WhatsApp through our Service, you
            agree to:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Use the data only as permitted by Facebook&apos;s Platform Terms</li>
            <li>
              Not use the data for any purpose that violates Meta&apos;s policies or applicable laws
            </li>
            <li>Respect user privacy and obtain necessary consents for data processing</li>
            <li>Not transfer, sell, or share Facebook data with third parties without consent</li>
            <li>Delete data upon user request or when required by Meta&apos;s policies</li>
            <li>Maintain appropriate security measures to protect the data</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            4.3 Prohibited Activities with Meta Data
          </h3>
          <p>You must NOT:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Use Facebook data to build or augment user profiles for advertising</li>
            <li>Transfer Facebook data to any ad network, data broker, or information broker</li>
            <li>Use Facebook data for surveillance purposes</li>
            <li>Scrape or collect data in violation of Meta&apos;s policies</li>
            <li>
              Circumvent any privacy features or restrictions implemented by Facebook, Instagram, or
              WhatsApp
            </li>
            <li>Use the data to contact users outside of the connected platforms</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            4.4 Termination by Meta Platforms
          </h3>
          <p>
            You acknowledge that Meta (Facebook, Instagram, WhatsApp) may suspend or terminate your
            access to their platforms at any time, which may affect your ability to use our Service.
            We are not responsible for any disruption, suspension, or termination of service caused
            by Meta&apos;s actions.
          </p>
          <p>
            If your Facebook, Instagram, or WhatsApp access is revoked, your ability to use the
            related features of our Service will be limited or terminated.
          </p>
        </div>
      </section>

      <section id="acceptable-use">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Acceptable Use Policy</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            You agree to use our Service only for lawful purposes and in accordance with these
            Terms. You agree NOT to:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Violate any applicable local, state, national, or international law</li>
            <li>Send spam, unsolicited messages, or engage in harassment</li>
            <li>Transmit malicious code, viruses, or harmful software</li>
            <li>Impersonate any person or entity or falsely represent your affiliation</li>
            <li>Interfere with or disrupt the Service or servers</li>
            <li>Attempt to gain unauthorized access to any part of the Service</li>
            <li>Use the Service to collect or store personal data of others without consent</li>
            <li>Engage in any activity that could damage, disable, or impair the Service</li>
          </ul>
          <p>
            We reserve the right to suspend or terminate your access to the Service if we determine,
            in our sole discretion, that you have violated this Acceptable Use Policy.
          </p>
        </div>
      </section>
    </>
  );
};
